module.exports = __webpack_public_path__ + "media/morse.bb9624a3.mp3";